<template>
    <el-button
            style="float: left"
            type="primary"
            :disabled="!isDraft"
            :loading="submitCraftRecordLoading"
            @click="submitCraftRecord"
            icon="el-icon-upload2"
            size="mini">提交
    </el-button>
</template>

<script>
    import {mapMutations, mapState} from 'vuex'

    export default {
        name: "SubmitCurrentCraftButton",
        props: {
            isDraft: {type: Boolean, required: true},
            checkSubmit: {
                type: Function,
                default: function () {
                    return () => {
                        return true
                    }
                }
            },
        },
        data() {
            return {submitCraftRecordLoading: false}
        },
        computed: {
            ...mapState(['currentCraft',])
        },
        methods: {
            // 提交工艺记录单
            submitCraftRecord() {
                // 监听 checkSubmit 事件
                // 并在提交时执行
                if (!this.checkSubmit()) {
                    return
                }

                this.submitCraftRecordLoading = true
                const submitUrl = `/order_platform/api/craft_records/${this.currentCraft.id}/submit/`
                this.$postRequest(submitUrl).then((response) => {
                    this.submitCraftRecordLoading = false
                    this.$message.success('提交成功')
                    const craft_record = response.data
                    this.updateCurrentCraft(craft_record)  // 更新 currentCraft
                }).catch(() => {
                    this.submitCraftRecordLoading = false
                })

            },
            ...mapMutations(['updateCurrentCraft'])
        },

    }
</script>

<style scoped>

</style>